// extracted by mini-css-extract-plugin
export default {"th":"ActionTable_th__vppJn","control":"ActionTable_control__8tBrp","icon":"ActionTable_icon__nPUWd"};